const SvgIcon = ({size = '1.2em', color = '#000'}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    fill="none"
    stroke={color}
    strokeLinecap="round"
    strokeLinejoin="round"
    strokeWidth="2"
    viewBox="0 0 24 24"
  >
    <path d="M10 11v6M14 11v6M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6M3 6h18M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
  </svg>
);

export default SvgIcon;

// const SvgIcon = ({size = 16, color = '#000'}) => (
//   <svg
//     xmlns="http://www.w3.org/2000/svg"
//     id="svg1489"
//     width={''+size}
//     height={''+size}
//     fill="none"
//     version="1.1"
//     viewBox="0 0 16 16"
//   >
//     <g
//       id="g1556"
//       strokeWidth="1.654"
//       transform="translate(.095 -.463)scale(.60451)"
//     >
//       <path
//         id="path1481"
//         stroke={color}
//         strokeLinecap="round"
//         strokeLinejoin="round"
//         d="m4.423 5.346 1.202 19.23c.057 1.112.865 1.924 1.923 1.924h11.058c1.062 0 1.855-.812 1.923-1.923l1.202-19.23"
//       ></path>
//       <path id="path1483" fill={color} d="M2.5 5.346h21.154Z"></path>
//       <path
//         id="path1485"
//         stroke={color}
//         strokeLinecap="round"
//         strokeMiterlimit="10"
//         d="M2.5 5.346h21.154"
//       ></path>
//       <path
//         id="path1487"
//         stroke={color}
//         strokeLinecap="round"
//         strokeLinejoin="round"
//         d="M9.23 5.346V2.942A1.44 1.44 0 0 1 10.674 1.5h4.808a1.44 1.44 0 0 1 1.442 1.442v2.404m-3.846 3.846v13.462M8.75 9.192l.48 13.462m8.174-13.462-.48 13.462"
//       ></path>
//     </g>
//   </svg>
// );
// 
// export default SvgIcon;
